import {getAxios} from './axios'
import {responseResolveInterceptor} from 'backend-helpers/interceptors';

export function getProfileWallMaterials(nick, order) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/profile/wall_materials/',
        method: 'get',
        params: {nick, order}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/profileWallPosts.js